/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-06 10:43:46
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-06 10:55:32
 * @FilePath: /unifyxp-v2-store-portal/src/components/QuestionIconTooltip/index.tsx
 */
import React from 'react';

import css from './css.module.less';

import { QuestionCircleFilled } from '@ant-design/icons';
import WhiteBackgroundTooltip, {
  TooltipContainer,
  TooltipTitle,
  TooltipContent,
  EnumPosition,
} from 'src/components/GlobalTooltip/WhiteBackgroundTooltip';
export { EnumPosition };
const QuestionIconTooltip = (props) => {
  const { title, content, iconClassName, placement } = props;
  return (
    <WhiteBackgroundTooltip
      title={
        <TooltipContainer>
          <TooltipTitle>{title}</TooltipTitle>
          <TooltipContent>{content}</TooltipContent>
        </TooltipContainer>
      }
      placement={placement || EnumPosition.rightBottom} //overlayClassName
    >
      <QuestionCircleFilled className={`${css.icon} ${iconClassName || ''}`} />
    </WhiteBackgroundTooltip>
  );
};
export default QuestionIconTooltip;
